import { render, staticRenderFns } from "./MealSelectWrapper.vue?vue&type=template&id=010aa952"
import script from "./MealSelectWrapper.vue?vue&type=script&lang=js"
export * from "./MealSelectWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports